import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

export default function Contact() {
  return (
    <>
      <h1 className='contact'>Contact</h1>
      <div className='filler'>
        <p>You can contact me through email <b>jefthedev@gmail.com</b> or social networks (links down below).</p>
      </div>
      <Footer />
    </>
  );
}